import {
  Button,
  IconClose,
  IconCommunicationFilled,
  IconMail,
  Text,
} from '@bbl-digital/snorre'
import { useIsMobile } from '@bbl-digital/snorre-v2'
import { MessageTypes } from 'Modules/Communication/shared/models/Inbox'
import {
  AnimatePresence,
  motion,
  useAnimate,
  useInView,
  Variants,
} from 'motion/react'
import { FC, useEffect, useState } from 'react'
import { cn } from 'shared/utils/cn'
import { CloseButtonCss, Tooltip } from './styles'

interface IProps {
  title: string
  type?: MessageTypes
  onClose: () => void
  onOpen: () => void
}

const CollapsedMessage: FC<IProps> = ({
  title,
  type = 'email',
  onClose,
  onOpen,
}) => {
  const isMobile = useIsMobile()
  const [scope, animate] = useAnimate()
  const [nudged, setNudged] = useState(false)
  const [hover, setHover] = useState(false)
  const isInView = useInView(scope)

  const isSms = type === 'sms'

  const wrapperVariants: Variants = {
    initial: {
      opacity: 0,
      x: 100,
    },
    animate: {
      opacity: 1,
      x: 0,
    },
  }

  const onAnimateOutAndOpen = () => {
    if (!isInView) {
      return
    }
    animate(scope.current, {
      opacity: 0,
      x: 100,
    }).then(() => {
      onOpen()
    })
  }

  useEffect(() => {
    if (!isInView) return

    const bounce = () =>
      animate(scope.current, {
        y: [0, -10, 0, -7.5, 0, -5, 0],
        transition: {
          duration: 0.4,
          scale: { type: 'spring', visualDuration: 0.4, bounce: 0.5 },
        },
      })

    if (!nudged) {
      setTimeout(() => bounce(), 1000)
      setNudged(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInView])

  return (
    <AnimatePresence>
      <motion.button
        ref={scope}
        initial="initial"
        animate="animate"
        onClick={onAnimateOutAndOpen}
        variants={wrapperVariants}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={cn(
          'fixed z-[1000] right-[0.5em] bottom-[4em] ',
          isSms && 'bottom-[8em]'
        )}
      >
        <motion.div
          whileHover={{ scale: 1.1 }}
          className={cn(
            'relative bg-surface-common-secondary rounded-full  flex w-[55px] h-[55px] items-center justify-center'
          )}
        >
          <>
            {type === 'email' ? (
              <IconMail color="white" size={35} />
            ) : (
              <IconCommunicationFilled color="white" size="27px" />
            )}
          </>

          <div>
            <Button nostyle onClick={onClose} css={CloseButtonCss}>
              <IconClose color="white" size="19" />
            </Button>
          </div>

          {title && !isMobile && (
            <motion.div
              initial={{ opacity: 0, y: -20, x: 20 }}
              animate={{ opacity: hover ? 1 : 0, x: hover ? 0 : 5 }}
              transition={{ duration: 0.2 }}
            >
              <Tooltip>
                <Text>{title}</Text>
              </Tooltip>
            </motion.div>
          )}
        </motion.div>
      </motion.button>
    </AnimatePresence>
  )
}

export default CollapsedMessage
